import type { StorageAdapter } from './StorageAdapter';

export class LocalStorageAdapter implements StorageAdapter {
  get(key: string): Promise<string | null> {
    try {
      return Promise.resolve(localStorage.getItem(key));
    } catch (error) {
      console.error('LocalStorageAdapter.get failed:', error);
      return Promise.resolve(null);
    }
  }

  set(key: string, value: string): Promise<void> {
    try {
      localStorage.setItem(key, value);
      return Promise.resolve();
    } catch (error) {
      console.error('LocalStorageAdapter.set failed:', error);
      return Promise.reject(error);
    }
  }

  delete(key: string): Promise<void> {
    try {
      localStorage.removeItem(key);
      return Promise.resolve();
    } catch (error) {
      console.error('LocalStorageAdapter.delete failed:', error);
      return Promise.reject(error);
    }
  }
}
